var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaticEmbeddingOn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 34,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 37.5,
  height: 29.5,
  x: 1.25,
  y: 1.25,
  stroke: "#CBE2F7",
  strokeWidth: 2.5,
  rx: 2.75
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#509EE3",
  d: "M14 12a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v5H14v-5ZM14 19h9v9h-7a2 2 0 0 1-2-2v-7ZM25 19h10v7a2 2 0 0 1-2 2h-8v-9Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CBE2F7",
  d: "M5 10h6v18H7a2 2 0 0 1-2-2V10ZM5 6a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v2H5V6Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaticEmbeddingOn);
export default ForwardRef;